import { ManagedReceivingPartnerApi as Api } from "@capstone/mock-api";
import type { CreateTicketScheduleDTO } from "@capstone/mock-api/src/shared-v2-types/help-assist.types";
import { Site } from "src/app/core/sites";
import { AppointmentReference } from "src/app/partner/appointments/base-appointment.model";
import { HelpAssistTicketAppointmentDraftUpdate } from "src/app/partner/help-assist/models/ticket-appointment-draft/help-assist-ticket-appointment-draft-update.model";
import { getUpdatedPropertiesFilter } from "src/utils";

export type HelpAssistTicketScheduleUpdateArgs =
  ClassProperties<HelpAssistTicketScheduleUpdate>;

export class HelpAssistTicketScheduleUpdate {
  public constructor({ ...args }: HelpAssistTicketScheduleUpdateArgs) {
    this.ticketAppointment = args.ticketAppointment;
    this.appointmentId = args.appointmentId;
    this.site = args.site;

    this.filterUpdatedProperties = getUpdatedPropertiesFilter(this, null, args);
  }

  public readonly ticketAppointment: HelpAssistTicketAppointmentDraftUpdate | null;
  public readonly appointmentId: AppointmentReference["id"] | null;
  public readonly site: Site;

  public readonly filterUpdatedProperties: FilterPartial<Api.HelpAssistTicketScheduleUpdate>;

  public serialize(): Partial<
    Api.HelpAssistTicketScheduleUpdate & {
      ticketAppointment: Partial<Api.HelpAssistTicketAppointmentDraftUpdate> | null;
    }
  > {
    const filterOptions = this.filterUpdatedProperties({
      appointmentId: this.appointmentId,
    });

    return {
      ...filterOptions,
      ticketAppointment: this.ticketAppointment?.serialize() ?? null,
    };
  }

  /**
   * Serializes all fields into a concrete {@link CreateTicketScheduleDTO}
   * for the V2 create-ticket endpoint.
   */
  public serializeForCreate(): CreateTicketScheduleDTO {
    return {
      appointmentId: this.appointmentId,
      ticketAppointment: this.ticketAppointment?.serializeForCreate() ?? null,
    };
  }
}
